class TriggerFieldType {
  constructor(slug, name, parent, weight, items) {
    this.slug = slug
    this.name = name
    this.parent = parent
    this.weight = weight
    this.items = items
  }
}

export function findTypeByID(fieldTypeId) {
  for (let el of fieldTypes) {
    let item = el.items.find(fieldType => fieldType.id === fieldTypeId)
    if (item !== undefined) {
      return item.value
    }
  }
}

// Hardcoded ID based on ifttt_front_end/lib/ifttt/developers/trigger_field_types.rb
// You could check actions and trigger fields for a channel with:
// curl -X GET https://ifttt.com/developers/api/channels/<module_name>/configuration  --header "Authorization: Token token=<token>"
function triggerFieldTypes() {
  return [
    new TriggerFieldType("field_type_group", "Input Type", 0, 10000, [
      { name: "Text input", next: "text_field_validation_type", id: 100 },
      { name: "Dropdown list", next: "dropdown_field_type", id: 200 },
      { name: "Location based input", next: "location_field_type", id: 300 },
      {
        name: "Nested dropdown list",
        next: "double_dropdown_field_type",
        id: 400,
      },
      {
        name: "Multiple checkbox selection",
        next: "checkbox_field_type",
        id: 1500,
      },
    ]),
    new TriggerFieldType(
      "text_field_validation_type",
      "Input validation",
      100,
      10100,
      [
        { name: "No validation required", value: "text_raw", id: 0 },
        { name: "Validation required", next: "text_field_type", id: 500 },
      ]
    ),
    new TriggerFieldType("text_field_type", "Validation rule", 500, 10200, [
      { name: "Text must not be blank", value: "text_not_blank", id: 1 },
      { name: "Text must be a URL", value: "text_url", id: 2 },
      { name: "Text must be an email address", value: "text_email", id: 3 },
      { name: "Text must match a custom regex", value: "text_regex", id: 4 },
      { name: "Validate text using my service", value: "text_dynamic", id: 5 },
    ]),
    new TriggerFieldType(
      "dropdown_field_type",
      "Data source for dropdown list",
      200,
      10300,
      [
        {
          name: "Populate with list items specified here",
          value: "dropdown_static",
          id: 6,
        },
        {
          name: "Retrieve list items from my service",
          value: "dropdown_dynamic",
          id: 7,
        },
      ]
    ),
    new TriggerFieldType(
      "location_field_type",
      "Location Field UI Type",
      300,
      10400,
      [
        { name: "A point", next: "location_point_validation_type", id: 800 },
        { name: "An area", next: "location_radius_validation_type", id: 900 },
        {
          name: "Enter an area",
          next: "location_enter_validation_type",
          id: 1000,
        },
        {
          name: "Exit an area",
          next: "location_exit_validation_type",
          id: 1100,
        },
        {
          name: "Enter or exit an area",
          next: "location_enter_and_exit_validation_type",
          id: 1200,
        },
      ]
    ),
    new TriggerFieldType(
      "location_point_validation_type",
      "Does this field need dynamic validation?",
      800,
      10500,
      [
        { name: "No, use default validation", value: "location_point", id: 8 },
        {
          name: "Yes, use dynamic validation",
          value: "location_point_dynamic",
          id: 9,
        },
      ]
    ),
    new TriggerFieldType(
      "location_radius_validation_type",
      "Does this field need dynamic validation?",
      900,
      10500,
      [
        {
          name: "No, use default validation",
          value: "location_radius",
          id: 10,
        },
        {
          name: "Yes, use dynamic validation",
          value: "location_radius_dynamic",
          id: 11,
        },
      ]
    ),
    new TriggerFieldType(
      "location_enter_validation_type",
      "Does this field need dynamic validation?",
      1000,
      10500,
      [
        { name: "No, use default validation", value: "location_enter", id: 12 },
        {
          name: "Yes, use dynamic validation",
          value: "location_enter_dynamic",
          id: 13,
        },
      ]
    ),
    new TriggerFieldType(
      "location_exit_validation_type",
      "Does this field need dynamic validation?",
      1100,
      10500,
      [
        { name: "No, use default validation", value: "location_exit", id: 14 },
        {
          name: "Yes, use dynamic validation",
          value: "location_exit_dynamic",
          id: 15,
        },
      ]
    ),
    new TriggerFieldType(
      "location_enter_and_exit_validation_type",
      "Does this field need dynamic validation?",
      1200,
      10500,
      [
        {
          name: "No, use default validation",
          value: "location_enter_and_exit",
          id: 16,
        },
        {
          name: "Yes, use dynamic validation",
          value: "location_enter_and_exit_dynamic",
          id: 17,
        },
      ]
    ),
    new TriggerFieldType(
      "double_dropdown_field_type",
      "Data source for nested dropdown list",
      400,
      10600,
      [
        {
          name: "Retrieve list items from my service",
          value: "dropdown_dynamic_double",
          id: 18,
        },
      ]
    ),
    new TriggerFieldType(
      "checkbox_field_type",
      "Data source for checkbox list",
      1500,
      10700,
      [
        {
          name: "Populate with checkbox items specified here",
          value: "checkbox_static",
          id: 20,
        },
        {
          name: "Retrieve checkbox items from my service",
          value: "checkbox_dynamic",
          id: 19,
        },
      ]
    ),
  ]
}

const fieldTypes = triggerFieldTypes()
export default fieldTypes
